import React from 'react';
import Spinner from 'src/view/shared/Spinner';
import ModeloTareaFormPage from '../form/ModeloTareaFormPage';

function ModeloTareaView(props) {
  const renderView = () => {
    const {record, drawer} = props;
    return <ModeloTareaFormPage record={record} disabled={true} drawer={drawer} />;
  };

  const {record, loading} = props;

  if (loading || !record) {
    return <Spinner />;
  }

  return renderView();
}

export default ModeloTareaView;
